import FormDatePicker from '../templates/FormDatePicker';
import { FormItemProps } from '../templates/FormProps';
import { DeviceTypes } from '@vindr/services/constants/common.constant';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { useGetDevices } from '@vindr/services/actions/devices.action';
import { filterValidValue } from '@vindr/utils/helpers/common.helper';
import { Select } from 'antd';
import FormSelect from "../templates/FormSelect";

type ParamsDevices = Parameters<typeof useGetDevices>[0];

interface Device extends FormItemProps {
  institution_ids: ParamsDevices['institution_ids'];
  modality?: ParamsDevices['modality'];
  procedure_id?: ParamsDevices['procedure_id'];
  procedure_group_id?: ParamsDevices['procedure_group_id'];
  types?: ParamsDevices['types'] | null;
  active?: ParamsDevices['active'];
  keyValue: 'code' | 'id';
  [key: string]: any;
}

const Device = ({
  name = 'device',
  label = 'Device',
  placeholder = 'Select Device',
  rules,
  required = true,
  onChange,
  disabled,
  multiple,
  institution_ids,
  modality,
  keyValue = 'code',
  noStyle,
  procedure_group_id,
  procedure_id,
  types = [DeviceTypes.Modality],
  active = true,
  ...props
}: Device) => {
  const [searchTerm, handleSearch] = useDebounce<string>();
  const { data, isInitialLoading, isRefetching } = useGetDevices(
    {
      limit: 100,
      offset: 0,
      institution_ids,
      active,
      ...filterValidValue({
        types,
        modality,
        procedure_group_id,
        procedure_id,
        name: searchTerm,
      }),
    },
    { enabled: !!institution_ids }
  );

  const devices = data?.data;

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...{ name, label, placeholder, disabled }}
      {...(multiple && { mode: 'multiple' })}
      {...(rules || (required && { rules: rulesMemo }))}
      {...props}
      onChange={(val) => {
        onChange?.(devices.find((item) => item[keyValue] === val));
      }}
      loading={isInitialLoading || isRefetching}
      required={required}
      noStyle={noStyle}
      showSearch={true}
      onSearch={handleSearch}
    >
      {devices?.map((device) => (
        <Select.Option key={device.id} value={device[keyValue]}>
          {device.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default Device;
